import { useApi } from './api';

export const useAccountService = () => {
  const { apiFetch } = useApi();

  // Trae todas las cuentas (usa fetch, pero puedes adaptar a axios si prefieres)
  const getAccounts = async () => {
    const res = await apiFetch('/accounts'); // ✅ CAMBIADO: URL relativa
    if (!res.ok) throw new Error('No se pudo obtener cuentas');
    return res.json();
  };

  const getAvailableAccounts = async () => {
    const res = await apiFetch('/accounts/available');
    if (!res.ok) throw new Error('No se pudieron obtener las cuentas disponibles');
    return res.json();
  };

  // ✅ NUEVO: Buscar cuentas con paginación
  const searchAccounts = async (
    page = 0,
    size = 10,
    search = '',
    active?: boolean,
    followUpUserId?: number | null,
    unassigned?: boolean
  ) => {
    const params = new URLSearchParams({
      page: page.toString(),
      size: size.toString()
    });
    
    if (search && search.trim()) {
      params.append('q', search.trim());
    }
    if (active !== undefined) {
      params.append('active', String(active));
    }
    if (unassigned) {
      params.append('unassigned', 'true');
    } else if (followUpUserId != null) {
      params.append('followUpUserId', String(followUpUserId));
    }
    
    const res = await apiFetch(`/accounts/search?${params.toString()}`); // ✅ CAMBIADO: URL relativa
    if (!res.ok) throw new Error('No se pudo buscar cuentas');
    return res.json();
  };

  // ✅ NUEVO: Sincronizar cuentas con ComPsych API
  const syncAccounts = async () => {
    const res = await apiFetch('/accounts/sync', { // ✅ CAMBIADO: URL relativa
      method: 'POST'
    });
    if (!res.ok) throw new Error('Error al sincronizar cuentas con ComPsych');
    return res.json();
  };

  // ✅ NUEVO: Obtener cuenta por ID
  const getAccountById = async (id: number) => {
    const res = await apiFetch(`/accounts/${id}`); // ✅ CAMBIADO: URL relativa
    if (!res.ok) throw new Error('No se pudo obtener la cuenta');
    return res.json();
  };

  const assignFollowUpUser = async (orgId: number, userId: number | null) => {
    const res = await apiFetch(`/accounts/${orgId}/follow-up-user`, {
      method: 'PUT',
      body: JSON.stringify({ userId })
    });
    if (!res.ok) throw new Error('No se pudo actualizar el usuario de seguimiento');
    return res.json();
  };

  const updateAccountStatus = async (orgId: number, isActive: boolean) => {
    const res = await apiFetch(`/accounts/${orgId}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ isActive })
    });
    if (!res.ok) throw new Error('No se pudo actualizar el estatus de la cuenta');
    return res.json();
  };

  return { 
    getAccounts,
    getAvailableAccounts,
    searchAccounts,
    syncAccounts,
    getAccountById,
    assignFollowUpUser,
    updateAccountStatus
  };
};